import { __decorate, __metadata } from "tslib";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import BaseMixer from "../../BaseMixer";
import { IDetailedNotificationDTO } from "@/store/models/notification/DetailedNotification";
import { NotificationsModule } from "@/store/modules/notification.module";
import { PAReviewModule } from "@/store/modules/paReview.module";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let ReviewNotificationComponent = /** @class */ (() => {
    var _a;
    let ReviewNotificationComponent = class ReviewNotificationComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.tenantId = localStorage.getItem("tenantId");
        }
        UpdateIsActive(notification) {
            if (!notification.isComplete) {
                return;
            }
            NotificationsModule.UpdateIsActive(notification.id);
            PAReviewModule.SetOperatingStepId(notification.notificationData.stepId);
            this.$router.push({ name: "ReviewListing" });
        }
        UpdateIsSeen() {
            NotificationsModule.UpdateIsSeen(this.notification.id);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDetailedNotificationDTO !== "undefined" && IDetailedNotificationDTO) === "function" ? _a : Object)
    ], ReviewNotificationComponent.prototype, "notification", void 0);
    ReviewNotificationComponent = __decorate([
        Component({
            name: "ReviewNotificationComponent",
            components: {},
        })
    ], ReviewNotificationComponent);
    return ReviewNotificationComponent;
})();
export default ReviewNotificationComponent;
